import dynamic from 'next/dynamic';
import Head from 'next/head';

import { getAdsDetail } from '@/Layout/Search/service';
import { capitalizeFLetter } from '@/utils/helpers';
const AdsDetails = dynamic(() => import('@/Layout/Search/AdsDetails'));
export const getServerSideProps = async ({ params }: any) => {
  const adsDetail = (await getAdsDetail({
    payload: {
      slug: params.ad_slug,
    },
  })) as any;

  return { props: { adsDetail, params } };
};
function Index({ adsDetail, params }: any) {
  const homePage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: adsDetail?.data?.details?.extra_title,
    description: `${capitalizeFLetter(adsDetail?.data?.details?.city)}-based call girl ${
      adsDetail?.data?.details?.extra_title?.split(' ')[0]
    } is well-known within the business for her secrecy and professionalism. She has a number of years of experience and a solid reputation for offering her clients top-notch services.`,
    url: `${process.env.REACT_BASE_URL}/ads-details/${params.ad_slug}`,
  };
  return (
    <>
      <Head>
        <title>{adsDetail?.data?.details.extra_title}</title>
        <meta name="title" content={adsDetail?.data?.details.extra_title} />
        <meta name="description" content={homePage.description} />
        <meta
          name="keyword"
          content={
            'Call girl Chennai, Call girl in Bangalore, Hyderabad call girl, Escort service Jaipur, Call girl Pune, Call girl in Mumbai, Udaipur call girl, Escort service Jaipur'
          }
        />
        <meta name="robots" content="noindex, follow" />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homePage) }}></script>
      </Head>
      <AdsDetails adsDetail={adsDetail?.data?.details} adsData={adsDetail?.data?.ads} />
    </>
  );
}
Index.auth = false;
Index.meta = {
  siteUrl: process.env.REACT_BASE_URL + '/ads-details',
  locale: 'en_us',
  ogTitle: 'Adult Classified site in India - 247torax',
  ogType: 'website',
  ogUrl: process.env.REACT_BASE_URL + '/ads-details',
  siteName: '247torax',
  ogDescription:
    'Meet with the high-profile call girls in your city. Find the call girl in Chennai, Bangalore, Hyderabad, Jaipur, Pune, Mumbai, Udaipur. POST YOUR AD absolutely FREE!',
};
export default Index;
